import { useNavigate } from "react-router-dom";
import { Play } from "lucide-react";
import { fileUrl } from "@/lib/api";

export default function AlbumCard({ album }) {
  const nav = useNavigate();
  const cover = fileUrl(album.cover_file_id);
  return (
    <div
      data-testid={`album-card-${album.id}`}
      onClick={() => nav(`/album/${album.id}`)}
      className="group cursor-pointer bg-card border border-border hover:border-primary transition-colors"
    >
      <div className="relative aspect-square bg-secondary overflow-hidden">
        {cover ? (
          <img src={cover} alt={album.title} className="w-full h-full object-cover transition-transform duration-200 group-hover:scale-105" />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-primary/20 to-black">
            <span className="font-display text-4xl font-bold text-white/20">{album.title?.[0]}</span>
          </div>
        )}
        <div className="absolute bottom-3 right-3 w-11 h-11 bg-primary flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all">
          <Play size={20} className="ml-0.5" />
        </div>
      </div>
      <div className="p-3">
        <div className="font-display font-semibold truncate">{album.title}</div>
        <div className="text-xs text-muted-foreground truncate">{album.artist} · {album.track_count || 0} tracks</div>
      </div>
    </div>
  );
}
